module.exports = __webpack_public_path__ + "static/media/youjiantougray@3x.3ffd1961.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/youjiantougray@3x.png
// module id = 395
// module chunks = 0